import { FC, SVGProps } from 'react';

export const LobbyIcon: FC<SVGProps<{ fill?: string }>> = ({
  fill = 'white',
}) => {
  return (
    <svg
      fill='none'
      height='32'
      viewBox='0 0 33 32'
      width='33'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.5 8.41962L12.9403 4C12.9403 4 24.8903 10.2337 26.8384 11.4391C28.7864 12.6444 29.943 14.1237 30.3874 16.4675C30.9231 19.28 29.4986 21.9768 27.1366 23.4074C24.939 24.7345 21.6273 26.2686 20.0689 27.0112C18.267 27.8696 15.3814 28.5575 11.8323 25.5137C7.74754 22.0133 8.73982 16.1813 8.73982 16.1813L2.5 12.3766V8.41962Z'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
      <path
        d='M19.7525 24.3039C20.0812 23.2263 20.1725 22.0393 19.9534 20.8887C19.509 18.551 18.1149 16.6943 16.4043 15.8603L5.36133 9.94922'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
      <path
        d='M19.4298 15.1328L15.9355 13.2578'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
      <path
        d='M25.299 12.6423L21.8047 10.7734'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
      <path
        d='M15.9355 13.2572L21.804 10.7734'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
      <path
        d='M19.4297 15.1283L25.2982 12.6445'
        stroke={fill}
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='1.4'
      />
    </svg>
  );
};
